import React, {createContext, useState} from "react";
import {pageContents} from "../Group/Content/pageContents";

export const GroupContext = createContext({});

export const GroupProvider = (props: any) => {
  const [content, setContent] = useState(pageContents.public);
  const [searchResult, setSearchResult] = useState(null);
  const [groupSearch, setGroupSearch] = useState("");
  const [publicGroup, setPublicGroup] = useState(null);
  const [pinGroups, setPinGroups]: any = useState(null);
  const [pinGroupsTotal, setPinGroupsTotal] = useState(0);
  const [conferenceGroup, setConferenceGroup] = useState(null);
  const [ownGroup, setOwnGroup] = useState(null);
  const [myGroup, setMyGroup] = useState(null);
  const [publicGroupTotal, setPublicGroupTotal] = useState(0);
  const [ownGroupTotal, setOwnGroupTotal] = useState(0);
  const [myGroupTotal, setMyGroupTotal] = useState(0);
  const [searchResultTotal, setSearchResultTotal] = useState(0);
  const [showRigthMenu, setShowRigthMenu] = useState(false);
  const [groupFilter, setGroupFilter]: any = useState(null);
  const [groupFilterMainType, setGroupFilterMainType]: any = useState("");

  const stateValue = {
    content: content,
    setContent: setContent,
    searchResult: searchResult,
    setSearchResult: setSearchResult,
    groupSearch: groupSearch,
    setGroupSearch: setGroupSearch,
    publicGroup: publicGroup,
    setPublicGroup: setPublicGroup,
    conferenceGroup: conferenceGroup,
    setConferenceGroup: setConferenceGroup,
    ownGroup: ownGroup,
    setOwnGroup: setOwnGroup,
    myGroup: myGroup,
    setMyGroup: setMyGroup,
    setShowRigthMenu: setShowRigthMenu,
    publicGroupTotal: publicGroupTotal,
    setPublicGroupTotal: setPublicGroupTotal,
    ownGroupTotal: ownGroupTotal,
    setOwnGroupTotal: setOwnGroupTotal,
    myGroupTotal: myGroupTotal,
    setMyGroupTotal: setMyGroupTotal,
    searchResultTotal: searchResultTotal,
    setSearchResultTotal: setSearchResultTotal,
    groupFilter,
    setGroupFilter,
    groupFilterMainType,
    setGroupFilterMainType,
    pinGroups,
    setPinGroups,
    pinGroupsTotal,
    setPinGroupsTotal
  };

  return (
    <GroupContext.Provider value={stateValue}>
      {props.children}
    </GroupContext.Provider>
  );
};
